import { useState, useEffect } from 'react'
import api, { IPageInfo, INeighborhoodImportVersion } from '@api'
import { IGridTableCell, GridTableStatusEnum } from '@ui'

export type Event = 'created'

const allEvents: Event[] = ['created']

export default function useImportDetails(id: string) {
  const [details, setDetails] = useState<IGridTableCell<INeighborhoodImportVersion>[]>([])
  const [status, setStatus] = useState<GridTableStatusEnum>(GridTableStatusEnum.LOADING)
  const [pageInfo, setPageInfo] = useState<IPageInfo | null>(null)
  const [createdAt, setCreatedAt] = useState('')
  const [importedBy, setImportedBy] = useState('')

  const onNextPage = () => {
    setStatus(GridTableStatusEnum.LOADING)
    api.neighborhood.import
      .details(id, pageInfo?.endCursor || '', allEvents)
      .then(({ details: newDetails, pageInfo: newPageInfo }) => {
        const newTableCells = newDetails.map((d) => ({ data: d }))
        setDetails([...details, ...newTableCells])
        setPageInfo(newPageInfo)
        setStatus(GridTableStatusEnum.IDLE)
      })
  }

  useEffect(() => {
    setStatus(GridTableStatusEnum.LOADING)
    api.neighborhood.import
      .details(id, null, allEvents)
      .then(({ details, pageInfo, createdAt, importedBy }) => {
        setDetails(details.map((d) => ({ data: d })))
        setPageInfo(pageInfo)
        setImportedBy(importedBy)
        setCreatedAt(createdAt)
        setStatus(GridTableStatusEnum.IDLE)
      })
  }, [id])

  return {
    details,
    pageInfo,
    onNextPage,
    importedBy,
    createdAt,
    status,
  }
}
